// import React, { useState, useEffect } from "react";
// import { getAuthorizationHeaders, GetMediaURL } from "./APICall";
// import { paths } from "./Constants";
// import { PiBuildingsLight } from "react-icons/pi";
// import { useAuth } from "./AuthProvider";

// function CustomImage({ location, className }) {
//   const [imageUrl, setImageUrl] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const { jwt } = useAuth();

//   useEffect(() => {
//     const fetchImage = async () => {
//       try {
//         const mediaURL = GetMediaURL(paths.media.download, location, {
//           quality: 20,
//         });
//         const headers = getAuthorizationHeaders(jwt);

//         const response = await fetch(mediaURL, {
//           method: "GET",
//           headers: headers,
//         });

//         if (!response.ok) throw new Error("Network response was not ok");

//         const blob = await response.blob();
//         const url = URL.createObjectURL(blob);
//         setImageUrl(url);
//       } catch (error) {
//         console.error("Error fetching the image:", error);
//       }
//     };

//     if (location) {
//       fetchImage();
//     }

//     return () => {
//       if (imageUrl) {
//         URL.revokeObjectURL(imageUrl);
//       }
//     };
//   }, [location, jwt]);

//   return (
//     <div
//       className={`flex justify-center items-center overflow-hidden ${className}`}
//     >
//       {imageUrl ? (
//         <img
//           src={imageUrl}
//           alt="Fetched from server"
//           className="object-cover w-full h-full"
//         />
//       ) : (
//         <div className="flex justify-center items-center w-full h-full">
//           <PiBuildingsLight size={50} color="grey" />
//         </div>
//       )}
//     </div>
//   );
// }

// export default CustomImage;

// import React, { useState, useEffect } from "react";
// import Lottie from "lottie-react"; // Import Lottie
// // import loaderAnimation from "./assets/animations/loader.json"; // Assuming this path is correct relative to CustomImage.js
// import loaderAnimation from "../assets/animations/loader.json";
// import { getAuthorizationHeaders, GetMediaURL } from "./APICall";
// import { paths } from "./Constants";
// import {
//   PiBuildingsLight,
//   PiUserCircleLight,
//   PiFileTextLight,
//   PiHouseLight,
// } from "react-icons/pi";
// import { useAuth } from "./AuthProvider";

// export const IMAGE_TYPES = {
//   BUILDING: "building",
//   FLAT: "flat",
//   PROFILE: "profile",
//   DOCUMENT: "document",
//   DEFAULT: "default",
// };

// function CustomImage({
//   location,
//   className,
//   imageType = IMAGE_TYPES.BUILDING,
//   altText = "Displayed image",
//   loaderSize = 100, // New prop for loader size, default 100
// }) {
//   const [imageUrl, setImageUrl] = useState(null);
//   const [loading, setLoading] = useState(false); // Initialize to false, set to true only when fetching
//   const { jwt } = useAuth();

//   useEffect(() => {
//     let isMounted = true;
//     setImageUrl(null); // Reset image URL when location or jwt changes

//     if (location && jwt) {
//       // Only fetch if location and jwt are present
//       setLoading(true); // Set loading to true before starting the fetch
//       const fetchImage = async () => {
//         try {
//           const mediaURL = GetMediaURL(paths.media.download, location, {
//             quality: 20,
//           });
//           const headers = getAuthorizationHeaders(jwt);

//           const response = await fetch(mediaURL, {
//             method: "GET",
//             headers: headers,
//           });

//           if (!response.ok) {
//             console.error(
//               `Error fetching image: ${response.status} ${response.statusText} for location ${location}`
//             );
//             throw new Error("Network response was not ok");
//           }

//           const blob = await response.blob();
//           const url = URL.createObjectURL(blob);
//           if (isMounted) {
//             setImageUrl(url);
//           }
//         } catch (error) {
//           if (isMounted) {
//             console.error("Error fetching the image:", error);
//             setImageUrl(null); // Ensure imageUrl is null on error
//           }
//         } finally {
//           if (isMounted) {
//             setLoading(false);
//           }
//         }
//       };

//       fetchImage();
//     } else {
//       // If no location or no JWT, we are not loading an image from the server
//       setLoading(false);
//     }

//     return () => {
//       isMounted = false;
//       if (imageUrl) {
//         URL.revokeObjectURL(imageUrl);
//       }
//     };
//   }, [location, jwt]); // Removed imageUrl from deps

//   const renderFallbackIcon = () => {
//     // Determine icon size based on container or a fixed value
//     // For simplicity, using a fixed size, but you could make this dynamic
//     const iconSize =
//       Math.min(
//         parseInt(className?.match(/w-(\d+)/)?.[1] || "12", 10) * 4,
//         50
//       ) || 50; // Heuristic
//     const iconProps = { size: iconSize, color: "grey" };

//     switch (imageType) {
//       case IMAGE_TYPES.PROFILE:
//         return <PiUserCircleLight {...iconProps} />;
//       case IMAGE_TYPES.DOCUMENT:
//         return <PiFileTextLight {...iconProps} />;
//       case IMAGE_TYPES.FLAT:
//         return <PiHouseLight {...iconProps} />;
//       case IMAGE_TYPES.BUILDING:
//       default:
//         return <PiBuildingsLight {...iconProps} />;
//     }
//   };

//   return (
//     <div
//       className={`flex justify-center items-center overflow-hidden bg-gray-100 ${className}`}
//     >
//       {loading && location ? ( // Show loader only if actively loading and location is present
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           style={{ width: loaderSize, height: loaderSize }}
//         />
//       ) : imageUrl ? (
//         <img
//           src={imageUrl}
//           alt={altText || `Image for ${imageType}`}
//           className="object-cover w-full h-full"
//         />
//       ) : (
//         // Show fallback if not loading (or loading completed with error) and no image,
//         // or if there's no location to begin with
//         <div className="flex justify-center items-center w-full h-full">
//           {renderFallbackIcon()}
//         </div>
//       )}
//     </div>
//   );
// }

// export default CustomImage;

import React, { useState, useEffect, useMemo } from "react";
import Lottie from "lottie-react";
// Make sure this path is correct relative to CustomImage.js
import loaderAnimation from "../assets/animations/loader.json";
import { getAuthorizationHeaders, GetMediaURL } from "./APICall"; // Adjust path if needed
import { paths } from "./Constants"; // Adjust path if needed
import {
  PiBuildingsLight,
  PiUserCircleLight,
  PiFileTextLight,
  PiHouseLight,
  PiImageLight, // A generic image icon for default
} from "react-icons/pi";
import { useAuth } from "./AuthProvider"; // Adjust path if needed

export const IMAGE_TYPES = {
  BUILDING: "building",
  FLAT: "flat",
  PROFILE: "profile",
  DOCUMENT: "document",
  DEFAULT: "default", // A generic default
};

// Helper to determine dynamic size for icons, Lottie animation, and text
// Moved outside CustomImage so it's not redefined on every render
const getDynamicSize = (
  classNameString,
  baseMultiplier = 0.6,
  minSize = 20,
  maxSize = 100
) => {
  if (!classNameString) return Math.round((minSize + maxSize) / 2);
  const sizeMatch = classNameString.match(/(?:w-(\d+)|h-(\d+))/); // e.g. w-20, h-20
  if (sizeMatch) {
    const sizeInUnits = parseInt(sizeMatch[1] || sizeMatch[2], 10); // Tailwind units
    // 1 unit = 0.25rem = 4px.
    return Math.round(
      Math.max(minSize, Math.min(maxSize, sizeInUnits * 4 * baseMultiplier))
    );
  }
  return Math.round((minSize + maxSize) / 2);
};

// FallbackContent: Renders the appropriate fallback (initials or icon)
const FallbackContentDisplay = ({
  imageType,
  initials,
  containerClassName,
}) => {
  const iconSize = getDynamicSize(containerClassName, 0.6); // For icons
  // For initials text, typically smaller font relative to container than an icon
  const initialTextSize = getDynamicSize(containerClassName, 0.4, 12, 40);

  const commonIconProps = { size: iconSize, color: "grey" };

  if (imageType === IMAGE_TYPES.PROFILE) {
    if (initials) {
      // For profiles with initials, replicate the user's desired style
      return (
        <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-600 font-semibold">
          {/* Apply rounded-full here if it's always for initials, or let parent className handle shape */}
          <span style={{ fontSize: `${initialTextSize}px` }}>{initials}</span>
        </div>
      );
    } else {
      // Profile image, no initials, show profile icon
      return <PiUserCircleLight {...commonIconProps} />;
    }
  }

  // Fallback for other image types
  switch (imageType) {
    case IMAGE_TYPES.DOCUMENT:
      return <PiFileTextLight {...commonIconProps} />;
    case IMAGE_TYPES.FLAT:
      return <PiHouseLight {...commonIconProps} />;
    case IMAGE_TYPES.BUILDING:
      return <PiBuildingsLight {...commonIconProps} />;
    case IMAGE_TYPES.DEFAULT:
    default:
      return <PiImageLight {...commonIconProps} />; // Generic image icon for default
  }
};

function CustomImage({
  location,
  className, // e.g., "h-20 w-20 rounded-full"
  imageType = IMAGE_TYPES.DEFAULT, // Default to a generic type
  altText, // Alt text is now more important to be passed explicitly
  initials, // New prop for initials (primarily for profile images)
  // loaderSize prop is removed in favor of dynamic sizing based on className
}) {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const { jwt } = useAuth();

  useEffect(() => {
    let isMounted = true;
    // Reset image URL if location or jwt changes, to prevent showing old image briefly
    setImageUrl(null);

    if (location && jwt) {
      setLoading(true);
      const fetchImage = async () => {
        try {
          const mediaURL = GetMediaURL(paths.media.download, location, {
            quality: 20,
          });
          const headers = getAuthorizationHeaders(jwt);
          const response = await fetch(mediaURL, { method: "GET", headers });

          if (!response.ok) {
            console.error(
              `Error fetching image: ${response.status} ${response.statusText} for location ${location}`
            );
            throw new Error("Network response was not ok");
          }
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          if (isMounted) setImageUrl(url);
        } catch (error) {
          if (isMounted) console.error("Error fetching the image:", error);
          // imageUrl remains null, leading to fallback
        } finally {
          if (isMounted) setLoading(false);
        }
      };
      fetchImage();
    } else {
      setLoading(false); // No location or JWT, so not loading
    }

    return () => {
      isMounted = false;
      if (imageUrl) {
        // Check if imageUrl was set before revoking
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [location, jwt]);

  // Determine if the specific "profile with initials" fallback is active
  const isShowingProfileInitials =
    imageType === IMAGE_TYPES.PROFILE && initials && !imageUrl && !loading;

  // Main container gets bg-gray-100 unless it's the profile initials fallback (which uses bg-gray-200)
  const mainBgClass = isShowingProfileInitials ? "" : "bg-gray-100";

  // Dynamic Lottie loader size
  const effectiveLoaderSize = useMemo(
    () => getDynamicSize(className, 0.7, 40, 150),
    [className]
  );

  const defaultAltText = `Image for ${imageType}${initials ? ` (${initials})` : ""}`;

  return (
    <div
      className={`flex justify-center items-center overflow-hidden ${mainBgClass} ${className}`}
      role="img" // Accessibility: identify as image container
      aria-label={altText || defaultAltText}
    >
      {loading && location ? ( // Show loader only if actively trying to load a specified location
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          style={{ width: effectiveLoaderSize, height: effectiveLoaderSize }}
        />
      ) : imageUrl ? (
        <img
          src={imageUrl}
          alt={altText || defaultAltText}
          className="object-cover w-full h-full"
        />
      ) : (
        // Fallback content (initials or icon)
        // This inner div ensures FallbackContentDisplay can use w-full h-full correctly
        <div className="flex justify-center items-center w-full h-full">
          <FallbackContentDisplay
            imageType={imageType}
            initials={initials}
            containerClassName={className}
          />
        </div>
      )}
    </div>
  );
}

export default CustomImage;
